{
  "login.meta.title": {
    "translation": "تسجيل الدخول — {{brandName}} للمطورين"
  },
  "login.meta.description": {
    "translation": "تسجيل الدخول إلى {{brandName}} للمطورين"
  },
  "login.heading": {
    "translation": "{{brandName}} للمطورين"
  },
  "login.subtitle": {
    "translation": "مركز تكامل نقاط البيع للمطاعم"
  },
  "nav.brand.label": {
    "translation": "{{brandName}} للمطورين"
  },
  "login.email.label": {
    "translation": "البريد الإلكتروني للعمل"
  },
  "login.email.placeholder": {
    "translation": "you@company.com"
  },
  "login.email.error.required": {
    "translation": "البريد الإلكتروني مطلوب."
  },
  "login.email.error.invalid": {
    "translation": "أدخل عنوان بريد إلكتروني صالحاً (مثال: you@company.com)."
  },
  "login.email.error.nonWork": {
    "translation": "يرجى استخدام بريد إلكتروني العمل الخاص بشركتك."
  },
  "login.password.label": {
    "translation": "كلمة المرور"
  },
  "login.password.placeholder": {
    "translation": "أدخل كلمة المرور"
  },
  "login.password.show": {
    "translation": "إظهار كلمة المرور"
  },
  "login.password.hide": {
    "translation": "إخفاء كلمة المرور"
  },
  "login.password.error.required": {
    "translation": "كلمة المرور مطلوبة."
  },
  "login.password.error.incorrect": {
    "translation": "كلمة المرور غير صحيحة. حاول مرة أخرى أو أعد تعيينها."
  },
  "login.submit": {
    "translation": "تسجيل الدخول"
  },
  "login.submitting": {
    "translation": "جارٍ تسجيل الدخول..."
  },
  "login.cta.register": {
    "translation": "التقدم للحصول على وصول API"
  },
  "login.cta.existingPartner": {
    "translation": "شريك حالي؟ سجل هنا"
  },
  "login.cta.forgotPassword": {
    "translation": "نسيت كلمة المرور؟"
  },
  "login.error.locked": {
    "translation": "محاولات فاشلة كثيرة. حسابك مغلق لمدة 15 دقيقة."
  },
  "login.error.inactive": {
    "translation": "هذا الحساب لم يعد نشطاً. تواصل مع الدعم للمساعدة."
  },
  "login.error.notFound": {
    "translation": "لم نتعرف على هذا البريد الإلكتروني. تحقق من الأخطاء الإملائية أو قدم طلب وصول."
  },
  "login.error.invalidCredentials": {
    "translation": "بريد إلكتروني أو كلمة مرور غير صحيحة. حاول مرة أخرى أو أعد التعيين."
  },
  "login.error.networkFailure": {
    "translation": "فشل تسجيل الدخول. تحقق من اتصالك وحاول مجدداً."
  },
  "login.error.sessionExpired": {
    "translation": "انتهت جلستك. يرجى تسجيل الدخول مرة أخرى."
  },
  "register.meta.title": {
    "translation": "التقدم للحصول على وصول API — {{brandName}} للمطورين"
  },
  "register.meta.description": {
    "translation": "تقدم للحصول على وصول API لأنظمة ديليفري هيرو لنقاط البيع."
  },
  "register.heading": {
    "translation": "التقدم للحصول على وصول API"
  },
  "register.subtitle": {
    "translation": "أخبرنا عن شركتك والأسواق التي تعمل فيها."
  },
  "register.markets.label": {
    "translation": "الأسواق"
  },
  "register.markets.placeholder": {
    "translation": "اختر الأسواق"
  },
  "register.markets.selected": {
    "translation": "{{count}} أسواق مختارة"
  },
  "register.markets.search": {
    "translation": "البحث عن الدول"
  },
  "register.markets.editLabel": {
    "translation": "تعديل اختيار الأسواق"
  },
  "register.markets.apply": {
    "translation": "تطبيق"
  },
  "register.markets.error.required": {
    "translation": "اختر سوقاً واحداً على الأقل."
  },
  "register.firstName.label": {
    "translation": "الاسم الأول"
  },
  "register.firstName.placeholder": {
    "translation": "جان"
  },
  "register.firstName.error.required": {
    "translation": "الاسم الأول مطلوب."
  },
  "register.lastName.label": {
    "translation": "اسم العائلة"
  },
  "register.lastName.placeholder": {
    "translation": "سميث"
  },
  "register.lastName.error.required": {
    "translation": "اسم العائلة مطلوب."
  },
  "register.email.label": {
    "translation": "البريد الإلكتروني للعمل"
  },
  "register.email.placeholder": {
    "translation": "you@company.com"
  },
  "register.email.error.required": {
    "translation": "البريد الإلكتروني مطلوب."
  },
  "register.email.error.invalid": {
    "translation": "أدخل عنوان بريد إلكتروني صالحاً (مثال: you@company.com)."
  },
  "register.email.error.nonWork": {
    "translation": "يرجى استخدام بريد إلكتروني العمل الخاص بشركتك."
  },
  "register.email.error.duplicate": {
    "translation": "يوجد حساب بهذا البريد الإلكتروني. تسجيل الدخول بدلاً من ذلك؟"
  },
  "register.phone.label": {
    "translation": "الهاتف"
  },
  "register.phone.placeholder": {
    "translation": "+1 555 123 4567"
  },
  "register.phone.helper": {
    "translation": "أدخل رمز الدولة."
  },
  "register.phone.error.required": {
    "translation": "رقم الهاتف مطلوب."
  },
  "register.company.label": {
    "translation": "اسم الشركة"
  },
  "register.company.placeholder": {
    "translation": "آكمي كورب"
  },
  "register.company.error.required": {
    "translation": "اسم الشركة مطلوب."
  },
  "register.website.label": {
    "translation": "موقع الشركة"
  },
  "register.website.placeholder": {
    "translation": "https://acme.com"
  },
  "register.website.error.required": {
    "translation": "موقع الشركة مطلوب."
  },
  "register.website.error.invalid": {
    "translation": "أدخل رابطاً صالحاً يبدأ بـ https:// (مثال: https://acme.com)."
  },
  "register.vendors.label": {
    "translation": "عدد البائعين"
  },
  "register.vendors.placeholder": {
    "translation": "اختر نطاقاً"
  },
  "register.vendors.options.1_10": {
    "translation": "1–10"
  },
  "register.vendors.options.11_50": {
    "translation": "11–50"
  },
  "register.vendors.options.51_200": {
    "translation": "51–200"
  },
  "register.vendors.options.200plus": {
    "translation": "200+"
  },
  "register.vendors.error.required": {
    "translation": "اختر عدد البائعين الذين تديرهم."
  },
  "register.pgpKey.label": {
    "translation": "مفتاح PGP العام"
  },
  "register.pgpKey.placeholder": {
    "translation": "-----BEGIN PGP PUBLIC KEY BLOCK-----"
  },
  "register.pgpKey.helper": {
    "translation": "يُستخدم مفتاح PGP العام الخاص بك لتشفير بيانات اعتماد API بشكل آمن."
  },
  "register.pgpKey.error.required": {
    "translation": "مفتاح PGP العام مطلوب."
  },
  "register.terms.prefix": {
    "translation": "أوافق على "
  },
  "register.terms.termsLink": {
    "translation": "الشروط والأحكام"
  },
  "register.terms.separator": {
    "translation": " و "
  },
  "register.terms.privacyLink": {
    "translation": "سياسة الخصوصية"
  },
  "register.terms.error.required": {
    "translation": "يجب قبول الشروط والأحكام للمتابعة."
  },
  "register.submit": {
    "translation": "إرسال الطلب"
  },
  "register.submitting": {
    "translation": "جارٍ الإرسال..."
  },
  "register.error.submissionFailed": {
    "translation": "حدث خطأ أثناء إرسال طلبك. يرجى المحاولة مرة أخرى."
  },
  "register.cta.backToLogin": {
    "translation": "العودة إلى تسجيل الدخول"
  },
  "register_confirm.meta.title": {
    "translation": "تحقق من بريدك الإلكتروني — {{brandName}} للمطورين"
  },
  "register_confirm.meta.description": {
    "translation": "لقد أرسلنا لك بريداً إلكترونياً للتحقق."
  },
  "register_confirm.heading": {
    "translation": "تحقق من بريدك الإلكتروني"
  },
  "register_confirm.message": {
    "translation": "لقد أرسلنا بريداً إلكترونياً للتحقق إلى <strong>{{email}}</strong>. انقر على الرابط للتحقق من حسابك وتعيين كلمة المرور."
  },
  "register_confirm.cta.backToLogin": {
    "translation": "العودة إلى تسجيل الدخول"
  },
  "existing_partner.meta.title": {
    "translation": "شريك حالي — {{brandName}} للمطورين"
  },
  "existing_partner.meta.description": {
    "translation": "تسجيل كشريك حالي لتكامل نقاط البيع مع ديليفري هيرو."
  },
  "existing_partner.heading": {
    "translation": "هل أنت شريك حالي؟"
  },
  "existing_partner.subtitle": {
    "translation": "أدخل بريد العمل المسجل لديك وسنرسل لك رابط تحقق."
  },
  "existing_partner.email.label": {
    "translation": "البريد الإلكتروني للعمل"
  },
  "existing_partner.email.placeholder": {
    "translation": "you@company.com"
  },
  "existing_partner.email.helper": {
    "translation": "استخدم عنوان البريد الإلكتروني المسجل أثناء تكامل نقاط البيع الأصلي."
  },
  "existing_partner.email.error.required": {
    "translation": "البريد الإلكتروني مطلوب."
  },
  "existing_partner.email.error.invalid": {
    "translation": "أدخل عنوان بريد إلكتروني صالحاً (مثال: you@company.com)."
  },
  "existing_partner.email.error.notFound": {
    "translation": "لم نعثر على تطابق لهذا البريد الإلكتروني. تحقق من الأخطاء الإملائية أو قدّم طلب وصول."
  },
  "existing_partner.email.error.inactive": {
    "translation": "تكاملك غير نشط حالياً. يمكنك الوصول إلى البوابة في الوضع المعلق ريثما نعيد التحقق من حالتك."
  },
  "existing_partner.email.error.alreadySent": {
    "translation": "تم إرسال رابط التحقق مسبقاً. تحقق من بريدك الوارد أو انتظر قبل طلب رابط جديد."
  },
  "existing_partner.submit": {
    "translation": "البحث عن حسابي"
  },
  "existing_partner.submitting": {
    "translation": "جارٍ البحث..."
  },
  "existing_partner.success.sent": {
    "translation": "لقد أرسلنا رابط تحقق إلى {{email}}. انقر عليه لتعيين كلمة مرورك."
  },
  "existing_partner.error.apiFailure": {
    "translation": "حدث خطأ ما. يرجى المحاولة مرة أخرى أو التواصل مع الدعم."
  },
  "existing_partner.error.rateLimited": {
    "translation": "محاولات كثيرة جداً. يرجى الانتظار بضع دقائق قبل المحاولة مرة أخرى."
  },
  "existing_partner.cta.backToLogin": {
    "translation": "العودة إلى تسجيل الدخول"
  },
  "existing_partner.cta.returnToLogin": {
    "translation": "العودة إلى تسجيل الدخول"
  },
  "set_password.meta.title": {
    "translation": "تعيين كلمة مرورك — {{brandName}} للمطورين"
  },
  "set_password.meta.description": {
    "translation": "أنشئ كلمة مرور آمنة لحساب {{brandName}} للمطورين."
  },
  "set_password.heading": {
    "translation": "تعيين كلمة مرورك"
  },
  "set_password.subtitle": {
    "translation": "أنشئ كلمة مرور آمنة للوصول إلى حسابك."
  },
  "set_password.password.label": {
    "translation": "كلمة المرور الجديدة"
  },
  "set_password.password.placeholder": {
    "translation": "أدخل كلمة مرورك"
  },
  "set_password.password.show": {
    "translation": "إظهار كلمة المرور"
  },
  "set_password.password.hide": {
    "translation": "إخفاء كلمة المرور"
  },
  "set_password.password.error.required": {
    "translation": "كلمة المرور مطلوبة."
  },
  "set_password.password.error.tooShort": {
    "translation": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل."
  },
  "set_password.password.error.tooLong": {
    "translation": "يجب أن تكون كلمة المرور 72 حرفًا أو أقل."
  },
  "set_password.password.error.needsUppercase": {
    "translation": "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل."
  },
  "set_password.password.error.needsNumber": {
    "translation": "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل."
  },
  "set_password.password.error.needsSpecial": {
    "translation": "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل."
  },
  "set_password.password.rules.length": {
    "translation": "8 أحرف على الأقل"
  },
  "set_password.password.rules.maxLength": {
    "translation": "72 حرفًا أو أقل"
  },
  "set_password.password.rules.uppercase": {
    "translation": "حرف كبير واحد على الأقل"
  },
  "set_password.password.rules.number": {
    "translation": "رقم واحد على الأقل"
  },
  "set_password.password.rules.special": {
    "translation": "حرف خاص واحد على الأقل"
  },
  "set_password.confirmPassword.label": {
    "translation": "تأكيد كلمة المرور"
  },
  "set_password.confirmPassword.placeholder": {
    "translation": "أعد إدخال كلمة مرورك"
  },
  "set_password.confirmPassword.show": {
    "translation": "إظهار تأكيد كلمة المرور"
  },
  "set_password.confirmPassword.hide": {
    "translation": "إخفاء تأكيد كلمة المرور"
  },
  "set_password.confirmPassword.error.required": {
    "translation": "يرجى تأكيد كلمة مرورك."
  },
  "set_password.confirmPassword.error.mismatch": {
    "translation": "كلمتا المرور غير متطابقتين."
  },
  "set_password.submit": {
    "translation": "تعيين كلمة المرور وتسجيل الدخول"
  },
  "set_password.submitting": {
    "translation": "جارٍ تعيين كلمة المرور..."
  },
  "set_password.error.tokenInvalid": {
    "translation": "هذا الرابط غير صالح أو تم استخدامه بالفعل."
  },
  "set_password.error.tokenExpired": {
    "translation": "انتهت صلاحية هذا الرابط. يرجى طلب رابط جديد."
  },
  "forgot_password.meta.title": {
    "translation": "إعادة تعيين كلمة المرور — {{brandName}} للمطورين"
  },
  "forgot_password.meta.description": {
    "translation": "اطلب رابط إعادة تعيين كلمة المرور لحسابك في {{brandName}} للمطورين."
  },
  "forgot_password.heading": {
    "translation": "هل نسيت كلمة المرور؟"
  },
  "forgot_password.subtitle": {
    "translation": "أدخل بريد عملك الإلكتروني وسنرسل لك رابط إعادة التعيين."
  },
  "forgot_password.email.label": {
    "translation": "البريد الإلكتروني للعمل"
  },
  "forgot_password.email.placeholder": {
    "translation": "you@company.com"
  },
  "forgot_password.email.error.required": {
    "translation": "البريد الإلكتروني مطلوب."
  },
  "forgot_password.email.error.invalid": {
    "translation": "أدخل عنوان بريد إلكتروني صالحاً (مثال: you@company.com)."
  },
  "forgot_password.email.error.nonWork": {
    "translation": "يرجى استخدام بريد إلكتروني العمل الخاص بشركتك."
  },
  "forgot_password.submit": {
    "translation": "إرسال رابط الإعادة"
  },
  "forgot_password.submitting": {
    "translation": "جارٍ الإرسال..."
  },
  "forgot_password.sent.message": {
    "translation": "إذا كان هذا البريد الإلكتروني مسجلاً، ستصلك رسالة إعادة التعيين قريباً."
  },
  "forgot_password.sent.resend": {
    "translation": "إرسال رابط آخر"
  },
  "forgot_password.sent.cooldown": {
    "translation": "يمكنك إعادة الإرسال خلال {{seconds}} ثانية."
  },
  "forgot_password.cta.backToLogin": {
    "translation": "العودة إلى تسجيل الدخول"
  },
  "link_expired.meta.title": {
    "translation": "انتهت صلاحية الرابط — {{brandName}} للمطورين"
  },
  "link_expired.meta.description": {
    "translation": "انتهت صلاحية رابط التحقق الخاص بك."
  },
  "link_expired.heading": {
    "translation": "انتهت صلاحية الرابط"
  },
  "link_expired.message": {
    "translation": "انتهت صلاحية رابط التحقق أو أصبح غير صالح. اطلب رابطاً جديداً أدناه."
  },
  "link_expired.resend.submit": {
    "translation": "طلب رابط جديد"
  },
  "link_expired.resend.submitting": {
    "translation": "جارٍ الإرسال..."
  },
  "link_expired.resend.sent": {
    "translation": "تم إرسال رابط جديد إلى عنوان بريدك الإلكتروني."
  },
  "link_expired.resend.cooldown": {
    "translation": "يمكنك طلب رابط جديد خلال {{seconds}} ثانية."
  },
  "link_expired.cta.backToLogin": {
    "translation": "العودة إلى تسجيل الدخول"
  },
  "app_nav.dashboard": {
    "translation": "لوحة التحكم"
  },
  "app_nav.credentials": {
    "translation": "بيانات الاعتماد"
  },
  "app_nav.vendors": {
    "translation": "الشركاء"
  },
  "app_nav.docs": {
    "translation": "التوثيق"
  },
  "app_nav.support": {
    "translation": "الدعم"
  },
  "app_nav.logout": {
    "translation": "تسجيل الخروج"
  },
  "app_nav.lockedTooltip": {
    "translation": "متاح بعد الموافقة على الطلب"
  },
  "app_nav.collapseNav": {
    "translation": "طيّ شريط التنقل"
  },
  "app_nav.expandNav": {
    "translation": "توسيع شريط التنقل"
  },
  "pending_dashboard.meta.title": {
    "translation": "طلب قيد المراجعة — {{brandName}} للمطورين"
  },
  "pending_dashboard.meta.description": {
    "translation": "طلبك قيد المراجعة."
  },
  "pending_dashboard.alert.info.heading": {
    "translation": "الطلب قيد المراجعة"
  },
  "pending_dashboard.alert.info.submittedAt": {
    "translation": "تم الإرسال في {{date}}"
  },
  "pending_dashboard.alert.neutral.message": {
    "translation": "خيارات الدعم محدودة حتى تتم الموافقة على طلبك."
  },
  "pending_dashboard.welcome": {
    "translation": "مرحباً، {{name}}"
  },
  "pending_dashboard.body": {
    "translation": "طلبك المقدم من <strong>{{email}}</strong> قيد المراجعة. عادةً ما يستغرق ذلك من 2 إلى 3 أيام عمل. سنُعلمك عبر البريد الإلكتروني فور اتخاذ القرار."
  },
  "pending_dashboard.cta.checkStatus": {
    "translation": "تحقق من الحالة"
  },
  "pending_dashboard.cta.support": {
    "translation": "تواصل مع الدعم"
  },
  "active_dashboard.meta.title": {
    "translation": "لوحة التحكم — {{brandName}} للمطورين"
  },
  "active_dashboard.meta.description": {
    "translation": "حسابك معتمد وفعّال."
  },
  "active_dashboard.alert.success": {
    "translation": "حسابك معتمد وفعّال. مرحباً بك في {{brandName}} للمطورين."
  },
  "active_dashboard.welcome": {
    "translation": "مرحباً بعودتك، {{name}}"
  },
  "active_dashboard.subtitle": {
    "translation": "{{company}} · {{email}}"
  },
  "active_dashboard.tag": {
    "translation": "معتمد · {{date}}"
  },
  "active_dashboard.quickAccess.heading": {
    "translation": "وصول سريع"
  },
  "active_dashboard.quickAccess.open": {
    "translation": "فتح"
  },
  "active_dashboard.quickAccess.credentials.label": {
    "translation": "بيانات اعتماد واجهة برمجة التطبيقات"
  },
  "active_dashboard.quickAccess.credentials.description": {
    "translation": "عرض مفتاح API الخاص بك وتدويره."
  },
  "active_dashboard.quickAccess.vendors.label": {
    "translation": "الموردون"
  },
  "active_dashboard.quickAccess.vendors.description": {
    "translation": "إدارة الموردين المرتبطين وإضافة موردين جدد."
  },
  "active_dashboard.quickAccess.support.label": {
    "translation": "الدعم"
  },
  "active_dashboard.quickAccess.support.description": {
    "translation": "فتح التذاكر وتتبع حل المشكلات."
  },
  "active_dashboard.quickAccess.docs.label": {
    "translation": "وثائق API"
  },
  "active_dashboard.quickAccess.docs.description": {
    "translation": "تصفح مراجع نقاط النهاية للوسيط والمكونات الإضافية."
  },
  "support.meta.title": {
    "translation": "الدعم — {{brandName}} للمطورين"
  },
  "support.meta.description": {
    "translation": "عرض وإدارة تذاكر الدعم الخاصة بك."
  },
  "support.heading": {
    "translation": "الدعم"
  },
  "support.newTicket": {
    "translation": "إنشاء طلب جديد"
  },
  "support.submitted": {
    "translation": "تم إرسال التذكرة {{id}}. سنتواصل معك خلال 3–5 أيام عمل."
  },
  "support.empty.heading": {
    "translation": "لا توجد تذاكر حتى الآن"
  },
  "support.empty.message": {
    "translation": "افتح تذكرة إذا كنت بحاجة إلى مساعدة في التكامل."
  },
  "support.table.id": {
    "translation": "المعرف"
  },
  "support.table.subject": {
    "translation": "الموضوع"
  },
  "support.table.category": {
    "translation": "الفئة"
  },
  "support.table.status": {
    "translation": "الحالة"
  },
  "support.table.lastActivity": {
    "translation": "آخر نشاط"
  },
  "support.status.open": {
    "translation": "مفتوحة"
  },
  "support.status.in_progress": {
    "translation": "قيد التنفيذ"
  },
  "support.status.closed": {
    "translation": "مغلقة"
  },
  "support.category.application_status": {
    "translation": "حالة الطلب"
  },
  "support.category.technical_question": {
    "translation": "سؤال تقني"
  },
  "support.category.other": {
    "translation": "أخرى"
  },
  "support.category.credentials": {
    "translation": "بيانات الاعتماد"
  },
  "support.category.vendor_onboarding": {
    "translation": "إعداد البائع"
  },
  "support.category.orders": {
    "translation": "الطلبات"
  },
  "support.category.catalog": {
    "translation": "الكتالوج"
  },
  "support.new.heading": {
    "translation": "طلب دعم جديد"
  },
  "support.new.brand.label": {
    "translation": "العلامة التجارية"
  },
  "support.new.brand.placeholder": {
    "translation": "اختر علامة تجارية"
  },
  "support.new.brand.error.required": {
    "translation": "العلامة التجارية مطلوبة."
  },
  "support.new.relatedVendor.label": {
    "translation": "البائع المرتبط"
  },
  "support.new.relatedVendor.optional": {
    "translation": "(اختياري)"
  },
  "support.new.subject.label": {
    "translation": "الموضوع"
  },
  "support.new.subject.placeholder": {
    "translation": "صف مشكلتك بإيجاز"
  },
  "support.new.subject.error.required": {
    "translation": "الموضوع مطلوب."
  },
  "support.new.category.label": {
    "translation": "الفئة"
  },
  "support.new.category.placeholder": {
    "translation": "اختر فئة"
  },
  "support.new.category.error.required": {
    "translation": "الفئة مطلوبة."
  },
  "support.new.message.label": {
    "translation": "الوصف"
  },
  "support.new.message.placeholder": {
    "translation": "صف مشكلتك بالتفصيل (20 حرفاً على الأقل)..."
  },
  "support.new.message.error.required": {
    "translation": "الوصف مطلوب."
  },
  "support.new.message.error.tooShort": {
    "translation": "يجب أن يتكون الوصف من 20 حرفاً على الأقل."
  },
  "support.new.submit": {
    "translation": "إرسال التذكرة"
  },
  "support.new.submitting": {
    "translation": "جارٍ الإرسال..."
  },
  "support.new.cancel": {
    "translation": "إلغاء"
  },
  "support.new.submitError": {
    "translation": "تعذّر إرسال طلبك. تم حفظ مسودتك."
  },
  "support.new.download": {
    "translation": "تنزيل طلبك"
  },
  "support.new.draft.restored": {
    "translation": "لديك مسودة محفوظة من جلسة سابقة."
  },
  "support.new.draft.discard": {
    "translation": "تجاهل"
  },
  "support.detail.heading": {
    "translation": "تذكرة الدعم"
  },
  "support.detail.label.status": {
    "translation": "الحالة"
  },
  "support.detail.label.id": {
    "translation": "التذكرة"
  },
  "support.detail.label.brand": {
    "translation": "العلامة التجارية"
  },
  "support.detail.label.category": {
    "translation": "الفئة"
  },
  "support.detail.label.created": {
    "translation": "تاريخ الإنشاء"
  },
  "support.detail.label.lastActivity": {
    "translation": "آخر نشاط"
  },
  "support.detail.label.message": {
    "translation": "الوصف"
  },
  "support.detail.label.relatedVendors": {
    "translation": "الموردون ذوو الصلة"
  },
  "support.detail.thread.heading": {
    "translation": "النشاط"
  },
  "support.detail.thread.systemRole": {
    "translation": "النظام"
  },
  "support.detail.thread.systemEvent": {
    "translation": "تم فتح التذكرة"
  },
  "support.detail.thread.supportRole": {
    "translation": "فريق الدعم"
  },
  "support.detail.thread.partnerRole": {
    "translation": "أنت"
  },
  "support.detail.thread.mockReply": {
    "translation": "شكراً لتواصلك معنا. نحن نراجع طلبك وسنرد عليك خلال 3–5 أيام عمل."
  },
  "support.detail.reply.label": {
    "translation": "رد"
  },
  "support.detail.reply.placeholder": {
    "translation": "اكتب ردك هنا..."
  },
  "support.detail.reply.submit": {
    "translation": "إرسال الرد"
  },
  "support.detail.reply.sending": {
    "translation": "جارٍ الإرسال..."
  },
  "support.detail.reply.errorToast": {
    "translation": "فشل الرد. حاول مرة أخرى."
  },
  "support.detail.closed.note": {
    "translation": "هذه التذكرة مغلقة. لا يمكن إضافة مزيد من الردود."
  },
  "support.detail.close": {
    "translation": "إغلاق"
  },
  "vendors.meta.title": {
    "translation": "البائعون المتصلون — بوابة مطوري POS"
  },
  "vendors.meta.description": {
    "translation": "عرض وإدارة البائعين المتصلين عبر جميع المنصات."
  },
  "vendors.heading": {
    "translation": "البائعون المتصلون"
  },
  "vendors.addVendor": {
    "translation": "+ إضافة بائع"
  },
  "vendors.addSuccess": {
    "translation": "تم إرسال البائع {{vendorId}} بنجاح. الحالة: قيد المراجعة."
  },
  "vendors.statusNote": {
    "translation": "يتم تحديث الحالة كل ~60 ثانية."
  },
  "vendors.pendingSubmissions": {
    "translation": "طلبات قيد الانتظار"
  },
  "vendors.empty": {
    "translation": "لا يوجد بائعون يطابقون بحثك."
  },
  "vendors.search.placeholder": {
    "translation": "البحث بالاسم أو المعرف..."
  },
  "vendors.filter.integration": {
    "translation": "التكامل"
  },
  "vendors.filter.vendorGroup": {
    "translation": "مجموعة المورد"
  },
  "vendors.filter.clearAll": {
    "translation": "مسح الكل"
  },
  "vendors.add.heading": {
    "translation": "إضافة بائع"
  },
  "vendors.add.close": {
    "translation": "إغلاق"
  },
  "vendors.add.platform.label": {
    "translation": "المنصة"
  },
  "vendors.add.platform.placeholder": {
    "translation": "اختر منصة"
  },
  "vendors.add.country.label": {
    "translation": "الدولة"
  },
  "vendors.add.country.placeholder": {
    "translation": "اختر دولة"
  },
  "vendors.add.country.placeholderNoPlatform": {
    "translation": "اختر منصة أولاً"
  },
  "vendors.add.vendorCode.label": {
    "translation": "كود البائع"
  },
  "vendors.add.vendorCode.placeholder": {
    "translation": "مثال: 12345"
  },
  "vendors.add.vendorCode.helper": {
    "translation": "الكود الذي يقدمه جهة الاتصال في DH."
  },
  "vendors.add.vendorCode.error.required": {
    "translation": "كود البائع مطلوب."
  },
  "vendors.add.preview.label": {
    "translation": "معرف البائع الذي سيتم إرساله:"
  },
  "vendors.add.submit": {
    "translation": "إرسال البائع"
  },
  "vendors.add.submitting": {
    "translation": "جارٍ الإرسال..."
  },
  "vendors.add.error.duplicate": {
    "translation": "هذا البائع متصل بالفعل بحسابك."
  },
  "vendors.add.error.unavailable": {
    "translation": "خدمة الإدراج غير متاحة مؤقتاً. يرجى المحاولة مرة أخرى لاحقاً."
  },
  "vendors.add.error.submission": {
    "translation": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
  },
  "vendors.add.cancel": {
    "translation": "إلغاء"
  },
  "vendors.status.active": {
    "translation": "نشط"
  },
  "vendors.status.inactive": {
    "translation": "غير نشط"
  },
  "vendors.status.pending": {
    "translation": "قيد الانتظار"
  },
  "vendors.status.rejected": {
    "translation": "مرفوض"
  },
  "credentials.meta.title": {
    "translation": "بيانات اعتماد API — بوابة مطوري POS"
  },
  "credentials.meta.description": {
    "translation": "عرض وإدارة بيانات اعتماد API الخاصة بك لتكامل DH POS."
  },
  "credentials.heading": {
    "translation": "بيانات اعتماد API"
  },
  "credentials.subtitle": {
    "translation": "استخدم هذه البيانات لمصادقة تكاملك مع واجهات برمجة تطبيقات DH POS."
  },
  "credentials.copied": {
    "translation": "تم النسخ إلى الحافظة"
  },
  "credentials.apiKey.label": {
    "translation": "مفتاح API للإنتاج"
  },
  "credentials.apiKey.tag": {
    "translation": "إنتاج"
  },
  "credentials.apiKey.reveal": {
    "translation": "كشف"
  },
  "credentials.apiKey.hide": {
    "translation": "إخفاء ({{countdown}} ث)"
  },
  "credentials.apiKey.hidesIn": {
    "translation": "يُخفى في {{countdown}} ث"
  },
  "credentials.apiKey.copy": {
    "translation": "نسخ المفتاح"
  },
  "credentials.apiKey.warning": {
    "translation": "حافظ على أمان هذا المفتاح. لا تشاركه أو تضمّنه في الكود المصدري."
  },
  "credentials.chainCode.label": {
    "translation": "كود السلسلة"
  },
  "credentials.chainCode.copy": {
    "translation": "نسخ كود السلسلة"
  },
  "credentials.rotation.heading": {
    "translation": "هل تحتاج إلى تدوير مفتاح API الخاص بك؟"
  },
  "credentials.rotation.body": {
    "translation": "أرسل طلب دعم. يتولى فريق DH معالجة تدوير المفتاح."
  },
  "credentials.rotation.cta": {
    "translation": "إنشاء طلب دعم"
  },
  "lang_selector.label": {
    "translation": "اللغة"
  },
  "lang_selector.en": {
    "translation": "English"
  },
  "lang_selector.ar": {
    "translation": "العربية"
  },
  "lang_selector.tr": {
    "translation": "Türkçe"
  },
  "error.401.heading": {
    "translation": "انتهت الجلسة"
  },
  "error.401.message": {
    "translation": "انتهت جلستك. يرجى تسجيل الدخول مرة أخرى."
  },
  "error.403.heading": {
    "translation": "الوصول مرفوض"
  },
  "error.403.message": {
    "translation": "ليس لديك إذن لعرض هذه الصفحة."
  },
  "error.404.heading": {
    "translation": "الصفحة غير موجودة"
  },
  "error.404.message": {
    "translation": "الصفحة التي تبحث عنها غير موجودة."
  },
  "error.default.heading": {
    "translation": "حدث خطأ ما"
  },
  "error.default.message": {
    "translation": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى."
  },
  "lang_selector.es": {
    "translation": ""
  },
  "lang_selector.es-ES": {
    "translation": ""
  },
  "auth_nav.backToLogin": {
    "translation": ""
  },
  "vendors.add.integration.label": {
    "translation": "التكامل"
  },
  "vendors.add.integration.placeholder": {
    "translation": "اختر تكاملاً"
  },
  "vendors.add.noIntegrations": {
    "translation": "لا توجد تكاملات مرتبطة بحسابك بعد. يرجى التواصل مع الدعم لإعداد تكاملك قبل إضافة البائعين."
  },
  "vendors.add.vendorGroup.label": {
    "translation": "مجموعة البائعين"
  },
  "vendors.add.vendorGroup.placeholder": {
    "translation": "اختر مجموعة بائعين"
  },
  "vendors.add.vendorGroup.placeholderNoIntegration": {
    "translation": "اختر تكاملاً أولاً"
  },
  "vendors.add.vendorGroup.helper": {
    "translation": ""
  },
  "vendors.add.posVendorId.label": {
    "translation": "معرّف البائع عن بُعد"
  },
  "vendors.add.posVendorId.placeholder": {
    "translation": "مثال: KFC_001"
  },
  "vendors.add.posVendorId.helper": {
    "translation": "معرّف POS للبائع الذي يوفره جهة الاتصال في DH."
  },
  "vendors.add.posVendorId.error.required": {
    "translation": "معرّف البائع عن بُعد مطلوب."
  },
  "docs.endpoint.authHeaderDesc": {
    "translation": "رمز Bearer المُستخرج من نقطة نهاية المصادقة. الصيغة:"
  },
  "docs.endpoint.bodyDefaultDesc": {
    "translation": "حمولة JSON. راجع مثال الكود للبنية المتوقعة."
  },
  "docs.endpoint.contentTypeDesc": {
    "translation": "يجب أن يكون"
  },
  "docs.endpoint.deprecated": {
    "translation": "نقطة النهاية هذه مهجورة."
  },
  "docs.endpoint.deprecatedInstead": {
    "translation": "بدلاً من ذلك."
  },
  "docs.endpoint.deprecatedUse": {
    "translation": "استخدم"
  },
  "docs.endpoint.dynamicUrlBody": {
    "translation": "تستخدم نقطة النهاية هذه عنوان URL مسجلاً أثناء إعداد التكامل — وليس مساراً حرفياً."
  },
  "docs.endpoint.dynamicUrlTitle": {
    "translation": "عنوان URL ديناميكي للاستدعاء"
  },
  "docs.endpoint.paramColDesc": {
    "translation": "الوصف"
  },
  "docs.endpoint.paramColName": {
    "translation": "المعامل"
  },
  "docs.endpoint.pathParams": {
    "translation": "معاملات المسار"
  },
  "docs.endpoint.queryParams": {
    "translation": "معاملات الاستعلام"
  },
  "docs.endpoint.requestBody": {
    "translation": "جسم الطلب"
  },
  "docs.endpoint.requestHeaders": {
    "translation": "ترويسات الطلب"
  },
  "docs.endpoint.required": {
    "translation": "مطلوب"
  },
  "docs.endpoint.responseSample": {
    "translation": "الاستجابة"
  },
  "docs.endpoint.responses": {
    "translation": "الاستجابات"
  },
  "docs.endpoint.codeTab.curl": {
    "translation": ""
  },
  "docs.endpoint.codeTab.js": {
    "translation": ""
  },
  "docs.endpoint.jsComment.replaceBody": {
    "translation": ""
  },
  "docs.meta.home.title": {
    "translation": ""
  },
  "docs.meta.detail.titleFallback": {
    "translation": ""
  },
  "docs.meta.titleTemplate": {
    "translation": ""
  },
  "docs.heading": {
    "translation": "مرجع API ودليل المطوّرين"
  },
  "docs.menuClose": {
    "translation": "إغلاق قائمة التنقل"
  },
  "docs.menuCloseLabel": {
    "translation": "إغلاق"
  },
  "docs.menuOpen": {
    "translation": "فتح قائمة التنقل"
  },
  "docs.menuOpenLabel": {
    "translation": "القائمة"
  },
  "docs.nav.aria": {
    "translation": "أقسام توثيق API"
  },
  "docs.searchPlaceholder": {
    "translation": "ابحث في نقاط النهاية والأدلة..."
  },
  "docs.sectionMeta.endpoints_one": {
    "translation": "{{count}} نقطة نهاية"
  },
  "docs.sectionMeta.endpoints_other": {
    "translation": "{{count}} نقاط نهاية"
  },
  "docs.sectionMeta.guides_one": {
    "translation": "{{count}} دليل"
  },
  "docs.sectionMeta.guides_other": {
    "translation": "{{count}} أدلة"
  },
  "docs.subtitle": {
    "translation": "مرجع شامل لـ POS Middleware API و Plugin API. التكامل المباشر مع بنية Delivery Hero التحتية."
  },
  "docs.version": {
    "translation": "POS API"
  },
  "support.new.relatedVendor.placeholder": {
    "translation": "اختر الموردين"
  },
  "support.new.relatedVendor.search": {
    "translation": "بحث عن الموردين"
  },
  "support.new.relatedVendor.more": {
    "translation": "+{{count}} المزيد"
  },
  "support.new.relatedVendor.noResults": {
    "translation": "لا يوجد موردين يطابقون بحثك."
  },
  "docs.content.sections.guides.title": {
    "translation": ""
  },
  "docs.content.sections.guides.description": {
    "translation": ""
  },
  "docs.content.sections.middleware.title": {
    "translation": ""
  },
  "docs.content.sections.middleware.description": {
    "translation": ""
  },
  "docs.content.sections.plugin.title": {
    "translation": ""
  },
  "docs.content.sections.plugin.description": {
    "translation": ""
  },
  "docs.content.sections.reference.title": {
    "translation": ""
  },
  "docs.content.sections.reference.description": {
    "translation": ""
  },
  "docs.content.nav.guides.getting-started.title": {
    "translation": ""
  },
  "docs.content.nav.guides.access-integration.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.authentication.token.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.create.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.get.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.vendors.availability.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.vendors.info.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.catalog.import.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.catalog.item-availability.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.reports.order-reporting.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.create-legacy.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.orders.dispatch.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.catalog.menu-import.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.catalog.import-callback.title": {
    "translation": ""
  },
  "docs.content.nav.reference.order-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.catalog-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.store-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.order-report-service.title": {
    "translation": ""
  },
  "docs.content.nav.reference.terminology.title": {
    "translation": ""
  },
  "docs.content.nav.reference.faq.title": {
    "translation": ""
  },
  "docs.content.nav.reference.post-production.title": {
    "translation": ""
  },
  "docs.content.response.400.label": {
    "translation": ""
  },
  "docs.content.response.400.description": {
    "translation": ""
  },
  "docs.content.response.401.label": {
    "translation": ""
  },
  "docs.content.response.401.description": {
    "translation": ""
  },
  "docs.content.response.500.label": {
    "translation": ""
  },
  "docs.content.response.500.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.r201.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.r201.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.param.orderId": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.param.orderId": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.query.include": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.param.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.param.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.r202.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.r202.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.param.itemId": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.from": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.to": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.param.catalogImportCallback": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.description": {
    "translation": ""
  },
  "docs.content.guide.getting-started.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b0.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b1.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b2.i0": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b2.i1": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b3.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b4.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i0.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i0.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i1.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i1.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i2.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i2.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i3.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i3.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i4.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i4.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i5.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i5.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i6.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i6.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i7.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i7.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b0.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b1.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i0.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i0.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i1.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i1.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i2.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i2.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i3.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i3.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i4.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i4.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b3.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b4.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b5.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i0.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i0.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i1.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i1.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i2.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i2.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b7.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b9.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b10.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b12.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b13.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.h0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.h1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r4.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r4.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.title": {
    "translation": ""
  },
  "docs.content.guide.order-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b1.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b2.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i0.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i1.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i2.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i3.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i4.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b4.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b5.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i0.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i1.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i2.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i3.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b7.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c2": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b1.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i0.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i0.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i1.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i1.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i2.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i2.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i3.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i3.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i4.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i4.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b3.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b4.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b5.text": {
    "translation": ""
  },
  "docs.content.guide.store-management.title": {
    "translation": ""
  },
  "docs.content.guide.store-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i0.term": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i0.def": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i1.term": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i1.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.title": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b0.text": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i0.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i0.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i1.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i1.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i2.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i2.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.title": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i0.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i0.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i1.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i1.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i2.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i2.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i3.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i3.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i4.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i4.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i5.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i5.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i6.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i6.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i7.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i7.def": {
    "translation": ""
  },
  "docs.content.guide.faq.title": {
    "translation": ""
  },
  "docs.content.guide.faq.b0.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b1.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b2.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b3.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b4.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b5.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b6.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b7.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b8.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b9.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.title": {
    "translation": ""
  },
  "docs.content.guide.post-production.b0.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i0.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i1.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i2.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i3.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b2.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i0": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i1": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i2": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i3": {
    "translation": ""
  }
}
